import {
  ChangeDetectionStrategy,
  Component,
  ContentChild, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import { ArrUtil, deepClone, Dimension, DpValue, eppConfig, Indicator, objectLiteralEqual, RuntimeAggOption } from '@gspwidget/util';
import { ClickEventConfig, DatalessJumpConfig, FilterConfig, JumpTypes, WidgetBase, WidgetDevkitService } from '@gspwidget/widget-devkit';
import { ifFsDateRange, isFsFlat } from '@gspwidget/util';
import { TranslateService } from '@ngx-translate/core';

export interface TitleBarExtendBtn {
  contentType?: 'text' | 'materialIcons'
  content?: string
  icon?: string
  iconSize?: number
  clickEvent?: ClickEventConfig
  // jump?: DatalessJumpConfig
  operationId?: string
}

@Component({
  selector: 'lib-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleBarComponent implements OnInit, OnChanges {

  /** TODO: 是不是这个就能代替后面其他从 instance 上取来值的属性了？干掉？ */
  @Input() widgetInstance: WidgetBase
  @Input() icon = ''
  /** 标题 */
  @Input() showTitle = true
  @Input() title = ''
  /** 数字 */
  @Input() showNumber = false
  @Input() number = 0
  /** 设置按钮 */
  @Input() showSetting = false
  @Input() settingTitle: string
  @Output() clickSetting = new EventEmitter<any>()
  /** 刷新按钮 */
  @Input() showRefresh = false
  @Output() clickRefresh = new EventEmitter<any>()

  @Input() showfullscreen = true  //是否显示全屏按钮
  @Output() clickPreview = new EventEmitter<any>()  //全屏预览

  /** 是否启用跳转，开启后元部件配置中可配置全局联查 */
  @Input() jumpConfig: DatalessJumpConfig
  /** @deprecated 应改用 enableJump。全局联查配置 */
  @Input() jumpProperty
  /** @deprecated 应改用 enableJump。为了跳转时能取到数据的第一行，用来拼接跳转路由参数。 */
  @Input() data: any[]
  /** 筛选 */
  @Input() filterConfigs: FilterConfig[]
  /** 维度，用于运行时聚合 */
  @Input() dims: Dimension[] = []
  /** 是否显示运行时聚合 */
  @Input() showRuntimeAgg = false
  /** 扩展跳转按钮，外部自定义其内容、跳转、权限控制 */
  @Input() extendBtns: TitleBarExtendBtn[] = []

  @Output() filterChange = new EventEmitter<DpValue[]>()
  @Output() runtimeAggChange = new EventEmitter<RuntimeAggOption>()
  @Output() init = new EventEmitter<TitleBarComponent>()
  // @Output() exportPdf = new EventEmitter<any>()
  @Output() exportExcel = new EventEmitter<any>()
  /** 传入模板 */
  @ContentChild('leftTemplate') leftTemplate: TemplateRef<ElementRef>
  @ContentChild('rightTemplate') rightTemplate: TemplateRef<ElementRef>

  JumpTypes = JumpTypes

  /** 非 flat 的 fcs */
  outerFC: FilterConfig
  outerFCs: FilterConfig[]
  innerFCs: FilterConfig[]
  /** 被选中的、显示在外面的 fc */
  // selectedFC: FilterConfig
  /** flat 的 fc */
  flatFCs: FilterConfig[]

  /** 运行时聚合 */
  editingRuntimeAgg = new RuntimeAggOption()
  confirmedRuntimeAgg: RuntimeAggOption
  runtimeAggDropdownOpen = false

  readonly eppConfig = eppConfig

  constructor (
    public devkitSvc: WidgetDevkitService,
    public translate: TranslateService,
  ) { }

  ngOnInit () {
    this.init.emit(this)
  }

  ngOnChanges (changes: SimpleChanges) {
    if (changes.filterConfigs) {
      // this.outerFC = null
      this.outerFCs = null
      this.innerFCs = null
      const notFlatFCs = this.filterConfigs.filter(fc => !isFsFlat(fc.fs) && !fc.fs.isHide)
      this.outerFCs = notFlatFCs.filter(fc => !fc.fs.isHide && !fc.fs.isIn)
      this.innerFCs = notFlatFCs.filter(fc => !fc.fs.isHide && fc.fs.isIn)
      if(this.innerFCs[0] == null){
        this.innerFCs = null
      }
      // if (notFlatFCs && notFlatFCs[0]) this.outerFC = notFlatFCs[0]
      // if (notFlatFCs && notFlatFCs.length > 1) this.innerFCs = notFlatFCs.slice(1)
      this.flatFCs = this.filterConfigs.filter(fc => isFsFlat(fc.fs))
    }
  }
  /** 用于外部手动设置 runtime agg。因为每次都需要 deep clone，所以封装为手动调用的函数，而非模板绑定，以减少次数。 */
  public setRuntimeAgg (runtimeAgg: RuntimeAggOption) {
    if (!runtimeAgg) return
    this.editingRuntimeAgg = deepClone(runtimeAgg)
    this.confirmedRuntimeAgg = deepClone(runtimeAgg)
  }

  handleClickExtendBtn (btn: TitleBarExtendBtn) {
    this.devkitSvc.handleClickEvent(btn.clickEvent, {}, this.widgetInstance)
  }
  handleClickJump () {
    this.devkitSvc.jumpWithoutData(this.jumpConfig)
  }
  /** 把 filter 发来的结果值，加上 dpId 一起包装为 dpValues 发出去 */
  handleFilterSingleChange (value, fc: FilterConfig) {
    // 1. 普通：发出对应 1 个 dp 的单个值
    this.filterChange.emit([{
      value,
      dpId: fc.dpId,
    }])
  }
  handleFilterMultiChange (values: any[], fc: FilterConfig) {
    let dpValues
    // 2. 日期范围：发出对应 2 个 dp 的 2 个值
    if (ifFsDateRange(fc.fs)) {
      dpValues = [
        { value: values[0], dpId: fc.dpId },
        { value: values[1], dpId: fc.dpId2 },
      ]
    } else {
      // 3. 枚举多选：发出对应 1 个 dp 的多个值
      dpValues = [{
        // TODO: 多值的连接方式是否可配？
        value: values.join(','), dpId: fc.dpId
      }]
    }
    this.filterChange.emit(dpValues)
  }

  /** 聚合 */
  handleAddInd () {
    this.editingRuntimeAgg.indicators.push(new Indicator())
  }
  handleRemoveInd (ind: Indicator) {
    ArrUtil.Remove(this.editingRuntimeAgg.indicators, ind)
  }
  handleConfirmAgg () {
    this.runtimeAggDropdownOpen = false
    if (objectLiteralEqual(this.editingRuntimeAgg, this.confirmedRuntimeAgg)) return
    this.confirmedRuntimeAgg = deepClone(this.editingRuntimeAgg)
    this.runtimeAggChange.emit(this.confirmedRuntimeAgg)
  }
}

